import {createContext, Dispatch} from 'react';

type initialStateType = {
    _id:string,
    editView:string,
    payRollIncident:any,
    modalPayRollIncendent:boolean     
}

type ModalPartial = {
    state:initialStateType,
    dispatch: Dispatch<any>
}

export const initialState = {
    _id:'',
    editView:'',
    payRollIncident:{},
    modalPayRollIncendent:false,     
}

export enum Types {
    MODAL_PAYROLL_INCIDENT       = "MODAL_PAYROLL_INCIDENT",   
    CLOSE_PAYROLL_INCIDENT_MODAL = "CLOSE_PAYROLL_INCIDENT_MODAL",    
}

const ModalInitialState = {
    state:initialState,
    dispatch:() => null
}


const PayRollIncidentContext = createContext<ModalPartial>(ModalInitialState)

export default PayRollIncidentContext; 
